import axiosPackage from "axios";

// enums
import { LegacyClientPanelUrl } from "@/enums/LegacyClientPanelUrl";

const axiosInstance = axiosPackage.create({
  baseURL: import.meta.env.VITE_ENDPOINT_URL,
});

axiosInstance.interceptors.response.use(
  ({ data }) => data,
  (error) => {
    const statusCode = error.response.status;

    if (statusCode === 403) {
      window.location.href = LegacyClientPanelUrl.PANEL;
    }

    return Promise.reject(error);
  },
);

export const axios = axiosInstance;
